"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("../api/WickedApiClient");
var AuthHeaders_1 = require("../api/AuthHeaders");
var Logger_1 = require("../Logger/Logger");
var util_1 = require("util");
var router_1 = require("@angular/router");
var advertisement_service_1 = require("./advertisement.service");
var ngx_cookie_service_1 = require("ngx-cookie-service");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var i2 = require("@angular/router");
var i3 = require("./advertisement.service");
var i4 = require("ngx-cookie-service");
//@LogClass()
var UserService = /** @class */ (function () {
    function UserService(authClient, userClient, phoneValidationClient, route, advertisementService, cookieService) {
        this.authClient = authClient;
        this.userClient = userClient;
        this.phoneValidationClient = phoneValidationClient;
        this.route = route;
        this.advertisementService = advertisementService;
        this.cookieService = cookieService;
        this.services = null;
    }
    UserService.prototype.login = function (email, password, rememberme, returnUrl) {
        var _this = this;
        if (rememberme === void 0) { rememberme = true; }
        if (returnUrl === void 0) { returnUrl = ""; }
        return new Promise(function (rs, rj) {
            var loginModel = new WickedApiClient_1.LoginModel();
            loginModel.init({
                userName: email,
                password: password
            });
            if (rememberme) {
                localStorage.setItem("email", email);
            }
            else {
                localStorage.removeItem("email");
            }
            _this.services.progress = true;
            _this.authClient.login(loginModel).subscribe(function (result) {
                if (result.phoneVerificationRequired && !result.isDemo) {
                    _this.logout();
                    // rj("You must finish phone number verification");
                    var userDataObject = btoa(JSON.stringify({ userId: result.userId.toString(), userPhone: result.userPhone }));
                    _this.route.navigate(["/validate-phone/" + userDataObject]);
                }
                else {
                    if (result.error && result.error != "") {
                        rj(result.error);
                    }
                    else {
                        AuthHeaders_1.setAuthToken(result.token);
                        rs(returnUrl);
                    }
                }
                _this.services.progress = false;
            });
        });
    };
    UserService.prototype.logout = function () {
        this.advertisementService.clearSearchData();
        this.services.showStartVideo = false;
        this.clearSearchData();
        AuthHeaders_1.setAuthToken(undefined);
    };
    UserService.prototype.deleteAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userClient.deleteAccount().toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserService.prototype.clearSearchData = function () {
        this.cookieService.delete("search-data");
    };
    UserService.prototype.isAdmin = function () {
        return AuthHeaders_1.getUserTokenFieldSchema("role").indexOf("admin") > -1;
    };
    UserService.prototype.isDemo = function () {
        return AuthHeaders_1.getUserTokenFieldSchema("role").indexOf("demo") > -1;
    };
    UserService.prototype.isPremium = function () {
        var currentRole = AuthHeaders_1.getUserTokenFieldSchema("role");
        return currentRole.indexOf("premium") > -1;
    };
    UserService.prototype.register = function (email, phone, password, passwordConfirm, returnUrl) {
        var _this = this;
        if (returnUrl === void 0) { returnUrl = ""; }
        return new Promise(function (rs, rj) {
            var model = new WickedApiClient_1.RegistrationModel();
            model.init({
                email: email,
                password: password,
                passwordConfirmation: passwordConfirm,
                phone: phone
            });
            _this.services.progress = true;
            _this.userClient.register(model).subscribe(function (result) {
                if (result.error && result.error != "") {
                    rj(result.error);
                }
                else {
                    rs(returnUrl);
                }
                _this.services.progress = false;
            });
        });
    };
    UserService.prototype.resetPassword = function (email, returnUrl) {
        var _this = this;
        if (returnUrl === void 0) { returnUrl = ""; }
        return new Promise(function (rs, rj) {
            var model = new WickedApiClient_1.ResetPasswordModel();
            model.init({
                email: email
            });
            _this.services.progress = true;
            _this.userClient.resetPassword(model).subscribe(function (result) {
                if (result.error && result.error != "") {
                    rj(result.error);
                }
                else {
                    rs(returnUrl);
                }
                _this.services.progress = false;
            });
        });
    };
    UserService.prototype.getEmailFromCode = function (code) {
        var _this = this;
        return new Promise(function (rs, rj) {
            _this.services.progress = true;
            _this.userClient.getEmailFromCode(code).subscribe(function (result) {
                if (result.error && result.error != "") {
                    rj(result.error);
                }
                else {
                    rs(result.email);
                }
                _this.services.progress = false;
            });
        });
    };
    UserService.prototype.newPassword = function (email, code, password, passwordConfirm, returnUrl) {
        var _this = this;
        if (returnUrl === void 0) { returnUrl = ""; }
        return new Promise(function (rs, rj) {
            var model = new WickedApiClient_1.NewPasswordModel();
            model.init({
                email: email,
                code: code,
                password: password,
                passwordConfirm: passwordConfirm
            });
            _this.services.progress = true;
            _this.userClient.newPassword(model).subscribe(function (result) {
                if (result.error && result.error != "") {
                    rj(result.error);
                }
                else {
                    rs(returnUrl);
                }
                _this.services.progress = false;
            });
        });
    };
    UserService.prototype.sendPhoneValidationMessage = function (userId) {
        var _this = this;
        return new Promise(function (success, reject) {
            var model = new WickedApiClient_1.VerifyPhoneModel();
            model.init({
                userId: userId
            });
            _this.phoneValidationClient.sendPhoneValidationSms(model).subscribe(function (result) {
                if (result.error && result.error != "") {
                    reject(result.error);
                }
                else {
                    success("");
                }
            });
        });
    };
    UserService.prototype.validatePhone = function (userId, code) {
        var _this = this;
        return new Promise(function (success, reject) {
            var model = new WickedApiClient_1.ValidatePhoneModel();
            model.init({
                code: code,
                userId: userId
            });
            _this.userClient.validatePhone(model).subscribe(function (result) {
                if (result.error && result.error != "") {
                    reject(result.error);
                }
                else
                    success();
            });
        });
    };
    UserService.prototype.validateEmail = function (code, email, returnUrl) {
        var _this = this;
        if (returnUrl === void 0) { returnUrl = ""; }
        return new Promise(function (rs, rj) {
            var model = new WickedApiClient_1.ValidateModel();
            model.init({
                code: code,
                type: "email",
                value: email
            });
            _this.services.progress = true;
            _this.userClient.validateEmail(model).subscribe(function (result) {
                if (result.error && result.error != "") {
                    rj(result);
                }
                else {
                    rs(result);
                }
                _this.services.progress = false;
            });
        });
    };
    UserService.prototype.isTokenExpired = function () {
        return AuthHeaders_1.isTokenExpired();
    };
    UserService.prototype.isTokenExist = function () {
        if (AuthHeaders_1.getAuthToken()) {
            return true;
        }
        return false;
    };
    //@LoggerMethod()
    UserService.prototype.isAuthenticated = function () {
        return AuthHeaders_1.isAuthenticated();
    };
    //@LoggerMethod()
    UserService.prototype.getUserEmail = function () {
        return AuthHeaders_1.getUserTokenFieldSchema("emailaddress");
    };
    // @LoggerMethod()
    UserService.prototype.getUserPhone = function () {
        return AuthHeaders_1.getUserTokenFieldSchema("mobilephone");
    };
    // @LoggerMethod()
    UserService.prototype.getUserRole = function () {
        return AuthHeaders_1.getUserTokenFieldSchema("role");
    };
    UserService.prototype.getUserId = function () {
        var tmp = Number(AuthHeaders_1.getUserTokenFieldSchema("nameidentifier"));
        return util_1.isNumber(Number(tmp)) ? Number(tmp) : null;
    };
    UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.AuthClient), i0.ɵɵinject(i1.UserClient), i0.ɵɵinject(i1.PhoneValidationClient), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.AdvertisementService), i0.ɵɵinject(i4.CookieService)); }, token: UserService, providedIn: "root" });
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, Boolean, String]),
        __metadata("design:returntype", Promise)
    ], UserService.prototype, "login", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UserService.prototype, "logout", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String, String, String]),
        __metadata("design:returntype", Promise)
    ], UserService.prototype, "register", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], UserService.prototype, "resetPassword", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], UserService.prototype, "getEmailFromCode", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String, String, String]),
        __metadata("design:returntype", Promise)
    ], UserService.prototype, "newPassword", null);
    __decorate([
        Logger_1.LoggerMethod(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, String]),
        __metadata("design:returntype", Promise)
    ], UserService.prototype, "validateEmail", null);
    return UserService;
}());
exports.UserService = UserService;
